import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';

import Echo from 'laravel-echo';

import { NgModule, LOCALE_ID } from '@angular/core';
import { AppComponent } from './app.component';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { NgxMaskModule } from 'ngx-mask';
import { NgxPermissionsModule } from 'ngx-permissions';
import { AgmCoreModule } from '@agm/core';
import { environment } from 'src/environments/environment';
import { SortablejsModule } from 'ngx-sortablejs';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatDialogModule } from '@angular/material/dialog';
import { Utils } from './shared/utils/utils';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RequestInterceptor } from './interceptors/request.interceptor';
import { HttpLogginInterceptor } from './interceptors/http-loggin.interceptor';
import { DeviceDetectorService } from 'ngx-device-detector';
import { NgxCurrencyModule } from 'ngx-currency';
import { ChamadosClienteModule } from './modules/painel/modules-cliente/chamados-cliente/chamados-cliente.module';
import { MailUnsubscribeComponent } from './components/mail-unsubscribe/mail-unsubscribe.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from './shared/shared.module';

registerLocaleData(localePt);

declare global {
  interface Window {
    Echo: Echo;
    io: any;
  }
}

window.io = require('socket.io-client');

const customCurrencyMaskConfig = {
  align: "left",
  allowNegative: false,
  allowZero: true,
  decimal: ",",
  precision: 2,
  prefix: "R$ ",
  suffix: "",
  thousands: ".",
  nullable: true,
  min: null,
  max: null,
};

@NgModule({
  declarations: [
    AppComponent,
    MailUnsubscribeComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MDBBootstrapModule.forRoot(),
    SweetAlert2Module.forRoot(),
    NgxMaskModule.forRoot(),
    NgxPermissionsModule.forRoot(),
    AgmCoreModule.forRoot({ apiKey: environment.googleMapsKey }),
    SortablejsModule.forRoot({ animation: 150 }),
    NgxCurrencyModule.forRoot(customCurrencyMaskConfig),
    NgxSpinnerModule,
    NgbModule,
    MatDialogModule,
    HttpClientModule,
    ChamadosClienteModule,
    ReactiveFormsModule,
    SharedModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'pt' },
    { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpLogginInterceptor, multi: true },
    Utils,
    DeviceDetectorService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
